import { render, staticRenderFns } from "./EvaluationCriteria.vue?vue&type=template&id=c61718f8&scoped=true"
import script from "./EvaluationCriteria.vue?vue&type=script&lang=js"
export * from "./EvaluationCriteria.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCriteria.vue?vue&type=style&index=0&id=c61718f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61718f8",
  null
  
)

export default component.exports